<template>
    <main class="comms-page">
        <div class="slides-container">
            <iframe
                src="https://docs.google.com/presentation/d/e/2PACX-1vS8U2dIMGieW-STucWflGTv-nEM79xvSOI36qIHkk8mfZoKFLDodP_GFHWYj0d4mVERL3-5pV4f0HW0/embed?start=false&loop=false&delayms=6000000"
                frameborder="0"
                allowfullscreen="true"
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
            ></iframe>
        </div>
    </main>
</template>

<script>
export default {
    name: "CommsPage",
};
</script>

<style lang="scss" scoped>
.comms-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 100px);
    padding: 20px;

    .slides-container {
        position: relative;
        width: 100%;
        max-width: 1200px; // Maximum width for larger screens
        margin: 0 auto;

        // 16:9 aspect ratio container
        &::before {
            content: "";
            display: block;
            padding-top: 56.25%; // 9/16 = 0.5625 = 56.25%
        }

        iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: none;
            box-shadow:
                0 4px 6px rgba(0, 0, 0, 0.1),
                0 2px 4px rgba(0, 0, 0, 0.06);
            border-radius: 8px;
        }
    }

    // For very small screens, add some vertical margin
    @media only screen and (max-width: 600px) {
        padding: 10px;

        .slides-container {
            max-width: 100%;
        }
    }

    // For tablets and medium screens
    @media only screen and (min-width: 601px) and (max-width: 992px) {
        .slides-container {
            max-width: 90%;
        }
    }

    // For larger screens
    @media only screen and (min-width: 993px) {
        .slides-container {
            max-width: 1200px;
        }
    }
}
</style>
